import React from 'react';

/**
 * Surface - ChatGPT Calm base card component
 * White surface with subtle border and generous padding
 */
export const Surface = ({ children, className = '', ...props }) => {
  return (
    <div 
      className={`bg-surface border border-border-calm rounded-lg p-6 ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

/**
 * SurfaceCompact - Smaller padding variant
 */
export const SurfaceCompact = ({ children, className = '', ...props }) => {
  return (
    <div 
      className={`bg-surface border border-border-calm rounded-lg p-4 ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};
